import { render, staticRenderFns } from "./GarageDetail.vue?vue&type=template&id=a2933b00"
import script from "./GarageDetail.vue?vue&type=script&lang=js"
export * from "./GarageDetail.vue?vue&type=script&lang=js"
import style0 from "./GarageDetail.vue?vue&type=style&index=0&id=a2933b00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports